// packages/frontend/src/components/onboarding/OnboardingChecklistButton.tsx

import { Box, Tooltip } from '@chakra-ui/react';
import { MaterialIcon } from '../ui/MaterialIcon';

interface OnboardingChecklistButtonProps {
  completedCount: number;
  totalSteps: number;
  onOpenPanel: () => void;
  isComplete: boolean;
}

/**
 * Compact progress affordance in the nav rail footer.
 *
 * It used to render a labelled row too, behind `isSidebarExpanded`. The rail is
 * a fixed 72px and never expands, so that branch lost its only caller with the
 * sidebar and went with it — the count now lives in the tooltip, which is the
 * shape the rail always used.
 */
export function OnboardingChecklistButton({
  completedCount,
  totalSteps,
  onOpenPanel,
  isComplete,
}: OnboardingChecklistButtonProps) {
  return (
    <Tooltip label={`Getting started: ${completedCount} / ${totalSteps}`} placement="right">
      <Box
        as="button"
        aria-label="Open getting started guide"
        onClick={onOpenPanel}
        w="full"
        px={2}
        py={2}
        borderRadius="md"
        display="flex"
        alignItems="center"
        justifyContent="center"
        _hover={{ bg: 'sidebar.item.hover' }}
        _active={{ bg: 'sidebar.item.active' }}
        transition="background 0.15s"
      >
        <MaterialIcon name={isComplete ? 'task_alt' : 'checklist'} boxSize="20px" flexShrink={0} />
      </Box>
    </Tooltip>
  );
}
